import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { constants, LocalStorageService } from '@edassist/common';
import { Product } from '../../models/product/product.interface';
import { AuthenticationService } from '../auth/auth.service';

@Injectable({ providedIn: 'root' })
export class ActiveProductService {
	activeProduct: Observable<Product>;
	private readonly activeProductSubject: BehaviorSubject<Product>;

	constructor(private readonly authService: AuthenticationService) {
		let activeProductId = LocalStorageService.getItem(constants.localStorageKeys.TOKENS_HYBRID)?.activeProduct;

		// if the url includes /tuition and activeProductId is not set, set activeProductId to 1
		if (!activeProductId && window.location.pathname.includes('tuition')) {
			activeProductId = constants.PRODUCTS.WORKFORCE_EDUCATION_ID;
		}

		this.activeProductSubject = new BehaviorSubject<Product>({
			id: activeProductId,
			name: this.getProductNameFromId(activeProductId)
		});
		this.activeProduct = this.activeProductSubject.asObservable();
	}

	updateActiveProduct(product: Product): void {
		// TODO : Following updates are needed to satisfy certain pages of the old angular site.
		//  Need to be revisited when all the existing PPT pages are moved under SRD work.
		const baseSiteUserTokens = LocalStorageService.getItem(constants.localStorageKeys.TOKENS_HYBRID) ?? {};
		baseSiteUserTokens.activeProduct = product.id
		LocalStorageService.setItem(constants.localStorageKeys.USER_ACTIVE_PRODUCT, product);
		LocalStorageService.setItem(constants.localStorageKeys.TOKENS_HYBRID, baseSiteUserTokens);
		this.activeProductSubject.next(product);
	}

	getActiveProduct(): Product {
		return this.activeProductSubject.value;
	}

	getProductNameFromId(productId: number): string {
		return this.authService.currentUserValue?.productTypes?.find((productType) => productType.id === productId)?.name;
	}

	setActiveProductById(productId: number): void {
		const user = LocalStorageService.getItem(constants.localStorageKeys.CURRENT_USER_HYBRID)?.userDetails;
		const product = user?.productTypes?.find((productType: Product) => productType.id === productId);

		if (product) {
			this.updateActiveProduct(product);
		}
	}
}
